module.exports = __webpack_public_path__ + "static/img/1.71166ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/aboutus/img/1.jpg
// module id = DB03
// module chunks = 1